import { render } from "./LoadingAnnotations.vue?vue&type=template&id=90b74e8e&scoped=true"
import script from "./LoadingAnnotations.vue?vue&type=script&lang=js"
export * from "./LoadingAnnotations.vue?vue&type=script&lang=js"

import "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=90b74e8e&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b74e8e"]])

export default __exports__